import type { GridColumnVisibilityModel } from "@mui/x-data-grid";

/** The Employee ID column's grid `field` — the HRIS id list lives on `Nurse.externalEmployees`. */
export const TEAM_EMPLOYEE_ID_FIELD = "externalEmployees";

/**
 * The Team roster's curated default column visibility: the model the picker's "Reset" restores to, and
 * what seeds a user who has never touched the picker.
 *
 * Employee ID starts hidden. It was added for monthly HRIS audits (APP-271) rather than day-to-day
 * scheduling, and the roster grid already scrolls horizontally at 1280px — so it is opt-in for the
 * people doing the audit instead of another column everyone else has to scroll past.
 *
 * Anything absent from this model reads as visible, so adding a key here is the only way to default a
 * column off. `useColumnVisibility` merges a user's stored model OVER this one, which is what lets a
 * newly hidden-by-default column stay hidden for users who saved a layout before it existed.
 *
 * Pure by design (mirrors `NursesMatrixGrid/columnVisibility.ts`) so the column builder can import it
 * without dragging React contexts in.
 */
export const TEAM_DEFAULT_COLUMN_VISIBILITY: GridColumnVisibilityModel = {
	[TEAM_EMPLOYEE_ID_FIELD]: false,
	// The roster's default seven columns are Name · Role · Job · Contract · Started · Last login ·
	// Status. Everything below is a field people audit occasionally rather than scan, and each one
	// visible by default was width taken from the columns that are read on every visit — Status
	// reason worst of all, since it renders blank for every ACTIVE employee by design and so was a
	// full column of "--" on the default Active-only roster.
	departmentStatusDetails: false,
	email: false,
	phoneNumber: false,
	agencyName: false,
	union: false,
};
